import React from "react";
// import axios from "axios"
import { BACKEND_URL } from "../config/Constant";
// const URL= process.env.REACT_APP_BACKEND_URL
import api from "../utils/axiosInstance";
export const Register=async(data)=>{


   try{
    const response= await api.post(`${BACKEND_URL}/register`,data)
    return response
   }
   catch(error){
    return error
   }

}

export const AccountVerify=async(data)=>{

   
      try{
       const response= await api.post(`${BACKEND_URL}/account-verify`,data)
       return response
      }
      catch(error){
       return error
      }
   
   }

   export const forgotPassword=async(data)=>{

      
         try{
          const response= await api.post(`${BACKEND_URL}/forgot-password`,data)
          return response
         }
         catch(error){
          return error
         }
      
      }

 


      export const VerifyOtp=async(data)=>{
         try{
            const response= await api.post(`${BACKEND_URL}/account-verify`,data)
            return response
           }
           catch(error){
            return error
           }
      }


      export const SendOtp=async(data)=>{
         try{
            const response= await api.post(`${BACKEND_URL}/sendotp`,data)
            return response
           }
           catch(error){
            return error
           }
      }


      export const PreChecker=async(data)=>{
         try{
            const response= await api.post(`${BACKEND_URL}/pre-check`,data)
            return response
           }
           catch(error){
            return error
           }
      }

      export const ResetPassword=async(data)=>{
         try{
            const response= await api.post(`${BACKEND_URL}/reset-password`,data)
            return response
           }
           catch(error){
            return error
           }
      }